import { Empty } from '../../components/ui/Primitives.js';

/**
 * Honest placeholder for routes whose API modules are not built yet. Better
 * than a broken link or a screen that looks functional and silently does
 * nothing.
 */
export function PlaceholderPage({ title, phase }: { title: string; phase: string }) {
  return (
    <>
      <div className="arc-page-head">
        <div><h1 className="arc-h1">{title}</h1></div>
      </div>
      <div className="arc-card">
        <Empty
          icon="settings"
          title={`${title} is not built yet`}
          hint={`Planned for ${phase}. The navigation entry is here so the shape of the product is visible, but there is no API behind it yet.`}
        />
      </div>
    </>
  );
}
